import { generalConfigStore, setPageOrderTaking } from "@store";

// Type-guard : la page `ways["orderTaking"]` (typée via une index signature
// union, donc large) est une vraie page orderTaking exploitable seulement si
// elle expose un objet `orderTakingProduct`. Remplace le cast `as` par un
// narrowing runtime explicite (et couvre le cas page présente mais incomplète).
function isOrderTakingPage(page: unknown): page is OrderTakingPageType {
    return (
        typeof page === "object" &&
        page !== null &&
        typeof (page as OrderTakingPageType).orderTakingProduct === "object"
    );
}

// Persiste un patch partiel dans `orderTakingProduct` du template.
//
// Lit le store Valtio AU MOMENT de l'exécution (état "live"), et NON un snapshot
// capturé au rendu : `setPageOrderTaking` remplace tout l'objet, donc on merge
// sur l'état courant pour ne pas écraser un enregistrement concurrent (un patch
// catégorie ne doit pas perdre un patch produit écrit juste avant, et vice-versa).
//
// Source unique de la persistance pour les réglages d'affichage catégorie/produit
// (Menu, CategoryDisplayMode2Settings, ProductDisplaySettings) : toute évolution
// (null-guard, validation, logging) se fait ici, une seule fois.
export function persistOrderTakingPatch(extra: Record<string, unknown>): void {
    // Garde : un template incomplet/corrompu (ou un type de kiosk sans page
    // orderTaking) peut ne pas avoir cette page. Sans garde, l'accès à
    // `.orderTakingProduct` lèverait une TypeError lors d'un clic couleur/style
    // déclenché avant la fin du chargement du template.
    const orderTakingPage =
        generalConfigStore.project.template.pages.ways["orderTaking"];
    if (!isOrderTakingPage(orderTakingPage)) {
        return;
    }
    setPageOrderTaking({
        ...orderTakingPage.orderTakingProduct,
        ...extra,
    });
}
